import { render } from "./CardBlock.vue?vue&type=template&id=01d94d76&scoped=true"
import script from "./CardBlock.vue?vue&type=script&lang=js"
export * from "./CardBlock.vue?vue&type=script&lang=js"

import "./CardBlock.vue?vue&type=style&index=0&id=01d94d76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d94d76"]])

export default __exports__